module.exports = __webpack_public_path__ + "fonts/Cairo-SemiBold.df4b7a4f.ttf";